import { ProductDesign, ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/shared/behaviors/addProduct';
import platform from 'rangeConfig/shared/utils/platform';
import { getProductCardIconWithTooltip } from '../../utils/productCardUtils';

const categories = {
  desktop: [
    {
      id: 'shelving-units',
      products: [
        { path: 'type', value: ProductType.JONAXEL_FRAME_SHELF },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    }
  ],
  mobile: [
    {
      id: 'shelving-units',
      products: [
        { path: 'type', value: ProductType.JONAXEL_FRAME_SHELF },
        { path: 'design', value: ProductDesign.WHITE }
      ]
    }
  ]
};
const framesProductListConfig: ProductListConfig = {
  cardsTitle: '',
  cardsSubtitle: 'communicatedSizeText',
  mobileCardText: 'communicatedSizeText',
  categories: categories[platform],
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  productFilters: [],
  cluster: ['globalItemNo'],
  sortOrder: [{ path: 'dimensions.width' }, { path: 'dimensions.height' }],
  productCardIcon: getProductCardIconWithTooltip
};

export default framesProductListConfig;
